<script>
  import { onMount, afterUpdate, createEventDispatcher } from "svelte";
  import { ExpandButton } from "nature-immersive-svelte-components";

  import "./css/widget-theme.css";

  export let headline;
  export let standFirst;
  export let sectionsButtonMessage;
  export let sectionsButtonExpandedMessage;
  export let sections;
  export let articleId = "";
  export let coverImageAltText = "";

  let dispatch = createEventDispatcher();

  let mounted = false;
  let sectionsExpanded = true;

  let handleSectionsClick = () => {
    sectionsExpanded = !sectionsExpanded;
    dispatch("update");
  };

  onMount(() => {
    mounted = true;
    sectionsExpanded = false;
  });

  afterUpdate(() => {
    dispatch("update");
  });
</script>

<style>
  /* Modifiers */
  .nature-interactive-graphic {
    border-top: var(--s-2) solid #ffffff;
    position: relative;
  }

  .nature-interactive-graphic:before {
    content: "";
    border-top: 1.5px solid var(--color--text);
    width: 100%;
    height: 1.5px;
    position: absolute;
    top: calc(var(--s-2) * -1);
    left: 0;
  }

  .border-above {
    border-color: var(--text-color);
  }

  .padding-block-start {
    padding-block-start: var(--s-3);
  }

  .current {
    font-weight: 800;
  }

  /* Layout */

  img {
    width: 100%;
    display: block;
  }

  nav {
    max-width: none;
  }

  /* List items */
  li {
    max-width: none;
  }

  li a {
    text-decoration: none;
    color: var(--color--component);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: var(--s-2);
  }

  li a:before {
    content: "";
    border: 0.2em solid var(--color--component);
    border-radius: 50%;
  }
</style>

<main
  class="nature-interactive-graphic stack box"
  style="--box-space--component: var(--main-padding-space); --stack-space--component: var(--main-gap-space);"
  data-theme="widget"
>
  <div
    class="sidebar sidebar-on-right"
    style="--sidebar-content-min-width--component: 65%; --sidebar-space--component: var(--s1); --sidebar-width--component: 140px;"
  >
    <div class="stack">
      <h2 class="font-size:big-2">
        {@html headline}
      </h2>
      <p class="font-family:sans-serif">
        {@html standFirst}
      </p>
    </div>

    <div class="img-container">
      <img src="img/cover-thumbnail.jpg" alt={coverImageAltText} />
    </div>
  </div>

  <!-- Sections -->
  <div
    class="stack border-above padding-block-start"
    style="--stack-space--component: var(--list-outer-gap-space);"
  >
    {#if mounted}
      <ExpandButton
        expanded={sectionsExpanded}
        message={sectionsButtonMessage}
        expandedMessage={sectionsButtonExpandedMessage}
        on:click={handleSectionsClick}
      />
    {/if}

    {#if sectionsExpanded}
      <nav>
        <ul
          class="stack"
          style="--stack-space--component: var(--list-outer-gap-space);"
        >
          {#each sections as { sectionName, articles }}
            <li
              class="stack border-above"
              style="--stack-space--component: var(--list-gap-space);"
            >
              <h3 class="font-size:big-1">{sectionName}</h3>
              <ul
                class="stack font-family:sans-serif"
                style="--stack-space--component: var(--list-gap-space)"
              >
                {#each articles as { title, doi }}
                  <li class:current={doi === articleId}>
                    <a
                      href="https://www.nature.com/articles/{doi}"
                      target="_parent"
                      aria-current={doi === articleId ? "page" : null}
                      ><span>{@html title}</span></a
                    >
                  </li>
                {/each}
              </ul>
            </li>
          {/each}
        </ul>
      </nav>
    {/if}
  </div>
</main>
